export class GChartAxisLine {
  show = true;

  public constructor(init?: Readonly<GChartAxisLine>) {
    Object.assign(this, init);
  }
}
